// Custom.js

(() => {
  if (window.__atlasSmartMobileHeader) return;
  window.__atlasSmartMobileHeader = true;

  const mobile = window.matchMedia('(max-width: 767px)');
  let header = null;
  let previousY = Math.max(window.scrollY, 0);
  let ticking = false;

  const findHeader = () => {
    header = document.querySelector('[data-header-section]');
    return header;
  };

  const showHeader = () => {
    (header || findHeader())?.classList.remove('atlas-mobile-header-hidden');
  };

  const updateHeader = () => {
    const currentY = Math.max(window.scrollY, 0);
    const activeHeader = header || findHeader();

    if (!activeHeader || !mobile.matches) {
      showHeader();
      previousY = currentY;
      return;
    }

    const directionChange = currentY - previousY;
    const pastHeader = currentY > activeHeader.getBoundingClientRect().height;

    if (currentY <= 12 || directionChange < -3) {
      showHeader();
    } else if (directionChange > 3 && pastHeader) {
      activeHeader.classList.add('atlas-mobile-header-hidden');
    }

    previousY = currentY;
  };

  const requestUpdate = () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(() => {
      updateHeader();
      ticking = false;
    });
  };

  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('pageshow', updateHeader);
  mobile.addEventListener?.('change', updateHeader);
  document.addEventListener('shopify:section:load', () => {
    header = null;
    updateHeader();
  });

  updateHeader();
})();
